// extracted by mini-css-extract-plugin
export default {"card":"RelatedBlogCard_card__AfF0Z","date":"RelatedBlogCard_date__Xen8-","title":"RelatedBlogCard_title__5h4AE","description":"RelatedBlogCard_description__wuS6z"};